// PrivacyPolicy.js
import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 헤더 */}
        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img src="/logo.png" alt="청해 AI" className="h-12 w-12" />
              <div>
                <h1 className="text-3xl font-bold text-gray-900">초등학생 보호 정책</h1>
                <p className="text-gray-600">SafeAI Kids Platform Youth Protection Policy</p>
              </div>
            </div>
            <Link
              to="/"
              className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
            >
              홈으로 돌아가기
            </Link>
          </div>
        </div>

        {/* 정책 내용 */}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="prose max-w-none">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">🛡️ 5단계 콘텐츠 필터링 시스템</h2>

            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
              <div className="bg-red-50 p-4 rounded-lg text-center">
                <div className="text-3xl mb-2">🚫</div>
                <h3 className="font-semibold text-red-800">1단계</h3>
                <p className="text-sm text-red-600">하드코딩</p>
                <p className="text-xs text-red-500 mt-1">키워드 필터링</p>
              </div>
              <div className="bg-orange-50 p-4 rounded-lg text-center">
                <div className="text-3xl mb-2">✨</div>
                <h3 className="font-semibold text-orange-800">2단계</h3>
                <p className="text-sm text-orange-600">입력 프롬프트 교정</p>
                <p className="text-xs text-orange-500 mt-1">인공지능이 교정</p>
              </div>
              <div className="bg-yellow-50 p-4 rounded-lg text-center">
                <div className="text-3xl mb-2">🤖</div>
                <h3 className="font-semibold text-yellow-800">3단계</h3>
                <p className="text-sm text-yellow-600">솔라프로2 자체 policy</p>
                <p className="text-xs text-yellow-500 mt-1">Solar Pro2 내장 필터</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg text-center">
                <div className="text-3xl mb-2">📝</div>
                <h3 className="font-semibold text-green-800">4단계</h3>
                <p className="text-sm text-green-600">연령별 내용 출력</p>
                <p className="text-xs text-green-500 mt-1">학년에 맞게 조정</p>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg text-center">
                <div className="text-3xl mb-2">👨‍🏫</div>
                <h3 className="font-semibold text-blue-800">5단계</h3>
                <p className="text-sm text-blue-600">교사 모니터링</p>
                <p className="text-xs text-blue-500 mt-1">활동 추적 및 검토</p>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">📋 보호 정책 세부사항</h2>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">1. 콘텐츠 안전성</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li><strong>키워드 필터링</strong>: 47개 이상의 부적절한 단어를 사전 차단합니다</li>
              <li><strong>학년별 맞춤 필터</strong>: 저학년(1-3학년)과 고학년(4-6학년)에 차등 적용합니다</li>
              <li><strong>AI 기술</strong>: Upstage Solar Pro2 모델이 교육적으로 적합한 응답을 생성합니다</li>
              <li><strong>개인정보 보호</strong>: 전화번호, 이메일, 주소 등 민감 정보는 자동으로 마스킹됩니다</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">2. AI 기술 제공</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li><strong>사용 모델</strong>: Upstage Solar Pro2 (30.9B 파라미터)</li>
              <li><strong>특징</strong>: 한국어 특화 AI 모델로 교육 콘텐츠에 최적화</li>
              <li><strong>응답 제한</strong>: 학생용 약 300단어, 교사용 약 500단어 이내로 제한</li>
              <li><strong>안전 장치</strong>: 모델 자체에 내장된 안전 필터로 부적절한 응답 방지</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">3. 교사 모니터링</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li><strong>활동 추적</strong>: 모든 채팅 메시지와 이미지 생성 기록이 저장됩니다</li>
              <li><strong>교사 대시보드</strong>: 담당 교사가 학생들의 활동을 조회하고 검토할 수 있습니다</li>
              <li><strong>콘텐츠 관리</strong>: 교사가 부적절한 콘텐츠를 직접 삭제할 수 있습니다</li>
              <li><strong>학생별 이력</strong>: 개별 학생의 AI 사용 활동을 상세히 확인할 수 있습니다</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">4. 개인정보 보호</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>학생의 개인정보는 교육 목적으로만 사용됩니다</li>
              <li>대화 내용은 안전성 확인을 위해서만 저장되며, 제3자와 공유되지 않습니다</li>
              <li>모든 데이터는 암호화되어 안전하게 보관됩니다</li>
              <li>학부모 동의를 권장하며, 동의 양식을 제공하고 있습니다</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">5. 학년별 맞춤 서비스</h3>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li><strong>저학년(1-3학년)</strong>: 쉽고 간단한 단어, 짧은 문장, 이모지 활용</li>
              <li><strong>고학년(4-6학년)</strong>: 교육적 어휘, 명확한 설명, 사고력 촉진</li>
              <li><strong>입력 길이 제한</strong>: 학년에 따라 200-500자로 조절되어 적절한 수준 유지</li>
              <li><strong>긍정적 톤</strong>: 격려하고 지지하는 응답으로 학습 의욕 향상</li>
            </ul>

            <div className="bg-yellow-50 p-6 rounded-lg mb-6">
              <h3 className="text-xl font-semibold text-yellow-800 mb-3">⚠️ 중요 안내</h3>
              <ul className="list-disc pl-6 space-y-2 text-yellow-900">
                <li>본 플랫폼은 완벽한 콘텐츠 필터링을 보장하지 않습니다</li>
                <li>교사와 학부모의 지속적인 관심과 모니터링이 필요합니다</li>
                <li>안전성 개선을 위해 지속적으로 시스템을 업데이트하고 있습니다</li>
                <li>부적절한 콘텐츠 발견 시 즉시 교사에게 문의해주시기 바랍니다</li>
              </ul>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg mt-8">
              <h3 className="text-xl font-semibold text-blue-800 mb-3">📞 문의 및 지원</h3>
              <p className="text-blue-700 mb-2">
                <strong>개발자:</strong> 완도고등학교 국어교사 공지훈
              </p>
              <p className="text-blue-700 mb-2">
                <strong>이메일:</strong> <a href="mailto:purusil55@gmail.com" className="underline">purusil55@gmail.com</a>
              </p>
              <p className="text-blue-700 mb-2">
                <strong>지원기관:</strong> 완도SW교육체험센터
              </p>
              <p className="text-blue-700">
                <strong>AI 기술 제공:</strong> Upstage
              </p>
            </div>

            <div className="text-center mt-8 text-sm text-gray-500">
              <p>최종 업데이트: 2025년 11월</p>
              <p>본 정책은 학생들의 안전한 AI 학습 환경을 보장하기 위해 지속적으로 개선됩니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
